module.exports = __webpack_public_path__ + "img/image.181eaf66.png";